import * as React from 'react';
import { Button, Typography, ThemeProvider, useMediaQuery } from '@material-ui/core';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import { RootState } from '../../store/rootReducer'
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import UserPaneModal from '../Schedule/userPane/UserPaneModal';
import { useDispatch, useSelector } from 'react-redux';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { logOut } from '../../store/modules/authSlice';
import themeLight from "../../components/shared/theme";
import { MuiThemeProvider } from "@material-ui/core/styles";
import userIcon from "../../assets/icons/user.svg";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            height: '100%',
        },
        rightHandMenuButton: {
            color: '#fff',
            fontSize: 18,
        },
        userName: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: 18
        }
    })
);

export default React.memo(function RightHandMenu() {
    const { authStore } = useSelector((state: RootState) => state);
    const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
    const history = useHistory();
    const classes = useStyles();
    const isMobile = useMediaQuery(themeLight.breakpoints.only("xs"));

    React.useEffect(() => {

    }, []);

    const [AVdialogIsOpen, setAVDialogIsOpen] = React.useState(false);
    const AVopenDialog = () => setAVDialogIsOpen(true);
    const AVcloseDialog = () => setAVDialogIsOpen(false);

    const RightMenuOnStatus = (): JSX.Element => {
        let fullName = (authStore?.data?.givenName ?? '') + ' ' + (authStore?.data?.surName ?? '');
        let vehicleNumber = authStore?.vehicleNumber ?? '';

        if (authStore.data?.isSharedUser === true) {
            return (
                <div className={classes.root}>
                    {isMobile ? null : <div className={classes.userName}>{fullName}</div>}
                    <Button className={classes.rightHandMenuButton} onClick={() => { dispatch(logOut()) }}>
                        Logout
                    </Button>
                </div>
            );
        } else if (authStore?.vehicleNumber) {
            return (
                <Button className={classes.rightHandMenuButton} onClick={AVopenDialog} endIcon={<KeyboardArrowDownIcon />}>
                    {isMobile ? <img src={userIcon} alt="" /> : fullName + ' (' + vehicleNumber + ')'}
                </Button>
            );
        } else if (authStore.data?.isSharedUser === false && !authStore?.vehicleNumber) {
            return (
                <Button className={classes.rightHandMenuButton} onClick={AVopenDialog} endIcon={<KeyboardArrowDownIcon />}>
                    {isMobile ? <img src={userIcon} alt="" /> : fullName}
                </Button>
            );
        } else if (authStore.data?.givenName) {
            return (
                <Button className={classes.rightHandMenuButton} onClick={() => { dispatch(logOut()) }}>
                    Logout
                </Button>
            );
        } else {
            return (
                <></>
            );
        }
    }

    return (
        <div style={{backgroundColor:AVdialogIsOpen ?'#346CB0' : 'inherit'}} className={classes.root}>
            <RightMenuOnStatus />
            <MuiThemeProvider theme={themeLight} >
                <UserPaneModal open={AVdialogIsOpen} onClose={AVcloseDialog} thisUserId={authStore.userName} />
            </MuiThemeProvider>
        </div>
    );
});
